import { useToast } from "../../../../hooks/use-toast";

import Spinner from "../../../../components/spinner.components";
import { useNavigate, useParams } from "react-router-dom";
import { handleHttpError } from "../../../../utils/utils";
import { DialogClose } from "@radix-ui/react-dialog";
import {
  DialogContent,
  DialogHeader,
} from "../../../components/core/modal.core";
import Button from "../../../components/core/button.core";
import { useReleaseEarningsHttp } from "../../../hooks/http/campaigns/release-earnings.hook";

export const CampaignReleaseEarningsPartial: React.FunctionComponent = () => {
  const { execute: releaseEarningsHttp, fetching: releasingEarings } =
    useReleaseEarningsHttp();
  const { toast } = useToast();

  const { campaignId } = useParams();

  const navigate = useNavigate();

  async function releaseEarnings() {
    if (!campaignId) {
      return;
    }
    const response = await releaseEarningsHttp({
      body: null,
      pathParams: { id: campaignId },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    toast({
      content: "💸 Earnings released successfully",
      toastType: "success",
    });

    navigate(`/brands/campaigns/${campaignId}/metrics`);
  }
  return (
    <DialogContent className="flex flex-col items-center gap-16 py-10 border w-full max-w-2xl font-cabinetgrotesk text-black text-center">
      <DialogHeader className="flex items-center gap-2 w-full">
        <h2 className="font-semibold text-3xl text-center">
          Are you sure you wanna release
          <br /> earnings ?
        </h2>
        <p className="text-center text-secondary">
          This action will release the earnings for the creators of this
          campaign.
        </p>
      </DialogHeader>
      <div className="flex justify-center items-center gap-5 w-full">
        <DialogClose className="">
          <Button
            variant="secondary"
            className="px-20 py-4 w-56 font-semibold text-[18px]"
          >
            Cancel
          </Button>
        </DialogClose>
        <Button
          disabled={releasingEarings}
          onClick={releaseEarnings}
          className="px-20 py-4 w-56 font-semibold text-[18px]"
        >
          {releasingEarings ? <Spinner width={20} /> : "Release"}
        </Button>
      </div>
    </DialogContent>
  );
};
